export type PageStyle = 'classic' | 'island';
export const pageStyleKey = 'moyu-page-style';
export const defaultStyleKey = 'moyu-page-style-default-v1';
const legacyKeys = [
  'moyu:privacy:settings:v1',
  'moyu:privacy:notes:v1',
  'work-break-theme',
  'moyu-theme-welcome-v1',
  'moyu:lobby:simple',
  'moyu.island-plots.v3',
];
// Called before child providers write their first-visit settings.
// Keep explicit choices first, then pin the migration result separately so
// defaulting to island does not suppress the discovery hint.
export function resolvePageStyle(storage: Pick<Storage, 'getItem' | 'setItem'>): PageStyle {
  try {
    const selected = storage.getItem(pageStyleKey);
    if (selected === 'classic' || selected === 'island') return selected;
    const previousDefault = storage.getItem(defaultStyleKey);
    if (previousDefault === 'classic' || previousDefault === 'island') return previousDefault;
    const style = legacyKeys.some((key) => storage.getItem(key) !== null) ? 'classic' : 'island';
    try {
      storage.setItem(defaultStyleKey, style);
    } catch {}
    return style;
  } catch {
    return 'island';
  }
}
